// @ts-nocheck


import {
  createElementObject,
  createLayerComponent,
  extendContext } from
'@react-leaflet/core';
import LeafletDriftMarker from 'leaflet-drift-marker';

export const createDriftMarker = (props, context) => {
  const { position, ...options } = props;
  const instance = new LeafletDriftMarker(position, options);

  return createElementObject(
    instance,
    extendContext(context, { overlayContainer: instance })
  );
};

export const updateDriftMarker = (
instance,
prevProps,
nextProps) =>
{
  if (nextProps.position !== prevProps.position) {
    const slideOptions = {
      duration: nextProps.duration
    };
    if (typeof nextProps.keepAtCenter === 'boolean') {
      slideOptions.keepAtCenter = nextProps.keepAtCenter;
    }
    instance.slideTo(nextProps.position, slideOptions);
  }
  if (nextProps.icon !== prevProps.icon && nextProps.icon) {
    instance.setIcon(nextProps.icon);
  }
  if (nextProps.zIndexOffset !== prevProps.zIndexOffset) {
    instance.setZIndexOffset(nextProps.zIndexOffset || 0);
  }
  if (nextProps.opacity !== prevProps.opacity && nextProps.opacity != null) {
    instance.setOpacity(nextProps.opacity);
  }
  if (nextProps.draggable !== prevProps.draggable && instance.dragging) {
    if (nextProps.draggable) instance.dragging.enable();else
    instance.dragging.disable();
  }
};

export default createLayerComponent(createDriftMarker, updateDriftMarker);
